"use strict";
exports.__esModule = true;
exports.toAnchor = void 0;
var ramda_1 = require("ramda");
var text_1 = require("./text");
var toAnchor = function (prismicText) {
    var text = text_1.toText(prismicText);
    return text
        ? ramda_1.compose(ramda_1.toLower, ramda_1.replace(/[^\w\s-]/gi, ''), ramda_1.replace(' ', '-'))(text)
        : undefined;
};
exports.toAnchor = toAnchor;
//# sourceMappingURL=anchor.js.map